import * as React from 'react';

import SVGDynamicIcon, { SVGDynamicIconProps } from 'components/svg-dynamic-icon/SVGDynamicIcon';
import Popover from 'components/popover/Popover';

import './icon-with-popover.scss';

type Props = SVGDynamicIconProps & {
  label: string
}

const IconWithPopover = (props: Props) => (
  <Popover
    classNamePopover="icon-with-popover"
    triggerComponent={(
      <SVGDynamicIcon
        {...props}
      />
    )}
  >
    {props.label}
  </Popover>
);

export default IconWithPopover;
